import { TOGGLE_ANNOTATIONS_VISIBILITY_CLICK } from '../collaborations/types';

const initialState = false;

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case TOGGLE_ANNOTATIONS_VISIBILITY_CLICK:
            return !state;
        default:
            return state;
    }
}
